function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.866 1.00002L21.392 17.5C21.4797 17.652 21.5259 17.8245 21.5259 18C21.5259 18.1755 21.4797 18.348 21.392 18.5C21.3042 18.652 21.178 18.7783 21.026 18.866C20.8739 18.9538 20.7015 19 20.526 19H1.47397C1.29844 19 1.126 18.9538 0.973983 18.866C0.821967 18.7783 0.695733 18.652 0.607967 18.5C0.520202 18.348 0.473998 18.1755 0.473999 18C0.474 17.8245 0.520206 17.652 0.607974 17.5L10.134 1.00002C10.2217 0.84801 10.348 0.721783 10.5 0.634023C10.652 0.546263 10.8244 0.500061 11 0.500061C11.1755 0.500061 11.3479 0.546263 11.5 0.634023C11.652 0.721783 11.7782 0.84801 11.866 1.00002ZM9.99997 14V16H12V14H9.99997ZM9.99997 7.00002V12H12V7.00002H9.99997Z",
  fill: "#FFC733"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.dcacb702.svg";
export { ForwardRef as ReactComponent };